export class FundingTypeLabel_EN {
    fundingType: {
        fundingHeader: string;
        applicant: string;
        coApplicant: string;
        both: string;
        primaryBorrower: string;
        coApplicantBorrower: string;
    }

    constructor() {

        this.fundingType = {
            fundingHeader: "Funding Type",
            applicant: "Applicant",
            coApplicant: "Co-Applicant",
            both: "Both",
            primaryBorrower: "Primary Borrower",
            coApplicantBorrower: "Co - Applicant Borrower"
        }
    }
}